<form [formGroup]="form">
    <h1 mat-dialog-title *ngIf="data.id==null">Create Product Dimensions</h1>
    <h1 mat-dialog-title *ngIf="data.id!=null">Edit Product Dimensions</h1>
    <div mat-dialog-content style="min-height: 400px;">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Product No</label>
                    <input type="text" class="form-control" formControlName="productNo">
                    <div *ngIf="form.controls['productNo'].touched && !form.controls['productNo'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['productNo'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Product Name</label>
                    <input type="text" class="form-control" formControlName="name">
                    <div *ngIf="form.controls['name'].touched && !form.controls['name'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['name'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Dimension Unit</label>
                    <input type="text" class="form-control" formControlName="dimUnit">
                    <div *ngIf="form.controls['dimUnit'].touched && !form.controls['dimUnit'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['dimUnit'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Length</label>
                    <input type="text" class="form-control" formControlName="length">
                    <div *ngIf="form.controls['length'].touched && !form.controls['length'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['length'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Width</label>
                    <input type="text" class="form-control" formControlName="width">
                    <div *ngIf="form.controls['width'].touched && !form.controls['width'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['width'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Height</label>
                    <input type="text" class="form-control" formControlName="height">
                    <div *ngIf="form.controls['height'].touched && !form.controls['height'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['height'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Weight Unit</label>
                    <input type="text" class="form-control" formControlName="weightUnit">
                    <div *ngIf="form.controls['weightUnit'].touched && !form.controls['weightUnit'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['weightUnit'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Weight</label>
                    <input type="text" class="form-control" formControlName="weight">
                    <div *ngIf="form.controls['weight'].touched && !form.controls['weight'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['weight'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div mat-dialog-actions>
        <button class="btn btn-outline" (click)="onNoClick()">No Thanks</button>
        <button type="button" class="btn btn-primary" style="margin-left: 5px;" [disabled]="!form.valid"
            (click)="save()">Save</button>
    </div>
</form>